var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import axios from "axios";
import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
require('./bootstrap');
require('./home');
var appName = ((_a = window.document.getElementsByTagName('title')[0]) === null || _a === void 0 ? void 0 : _a.innerText) || 'OVForm';
if (document.getElementById('app')) {
    createInertiaApp({
        progress: {
            color: '#9fe346',
            showSpinner: true
        },
        title: function (title) { return "".concat(title, " - ").concat(appName); },
        resolve: function (name) {
            return require("./Pages/".concat(name, ".tsx"));
            // const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true })
            // let page = pages[`./Pages/${name}.jsx`]
            // page.default.layout = name.startsWith('Public/') ? undefined : page => <Layout children={page} />
            // return page
        },
        setup: function (_a) {
            var el = _a.el, App = _a.App, props = _a.props;
            return createRoot(el).render(_jsx(App, __assign({}, props)));
        },
    });
}
setInterval(function () {
    axios.get('/ping');
}, 3600 * 1000);
